import { toast as reactHotToast } from 'react-hot-toast';
import { TOAST_TYPE } from './constants';
const generateToastId = (message, type) => {
    let messageKey;
    if (typeof message === 'string') {
        messageKey = message;
    }
    else {
        try {
            messageKey = JSON.stringify(message);
        }
        catch (_a) {
            return undefined;
        }
    }
    return `${type}-${messageKey.slice(0, 100)}`;
};
export const toast = Object.assign((message, options) => {
    const id = (options === null || options === void 0 ? void 0 : options.id) || generateToastId(message, TOAST_TYPE.BLANK);
    return reactHotToast(message, id ? Object.assign(Object.assign({}, options), { id }) : options);
}, {
    error: (message, options) => {
        const id = (options === null || options === void 0 ? void 0 : options.id) || generateToastId(message, TOAST_TYPE.ERROR);
        return reactHotToast.error(message, id ? Object.assign(Object.assign({}, options), { id }) : options);
    },
    success: (message, options) => {
        const id = (options === null || options === void 0 ? void 0 : options.id) || generateToastId(message, TOAST_TYPE.SUCCESS);
        return reactHotToast.success(message, id ? Object.assign(Object.assign({}, options), { id }) : options);
    },
    loading: reactHotToast.loading,
    custom: reactHotToast.custom,
    promise: reactHotToast.promise,
    dismiss: reactHotToast.dismiss,
    remove: reactHotToast.remove,
});
//# sourceMappingURL=toastWrapper.js.map